








































































import Vue from 'vue'

export default Vue.extend({
  data () {
    return {
      newUrl: 'web.eu1.revas.app',
      copyState: 'idle' as 'idle' | 'copying' | 'copied'
    }
  },
  computed: {
    copyLabel (): string {
      const labels: Record<'idle' | 'copying' | 'copied', string> = {
        idle: 'Copia',
        copying: 'Copiando...',
        copied: '✓ Copiato'
      }
      return labels[this.copyState]
    }
  },
  methods: {
    async copyUrl () {
      this.copyState = 'copying'
      try {
        await navigator.clipboard.writeText(`https://${this.newUrl}`)
        this.copyState = 'copied'
        setTimeout(() => (this.copyState = 'idle'), 2000)
      } catch {
        this.copyState = 'idle'
      }
    }
  }
})
